import gsap from 'gsap'

export const ExpandableCard = (target: HTMLElement) => {
  const el = {
    root: target,
    expandedContent: target.querySelector<HTMLDivElement>('.expandable-card__expanded-content'),
    overlayBackground: target.querySelector<HTMLDivElement>('.expandable-card__overlay--background'),
    overlayBorder: target.querySelector<HTMLDivElement>('.expandable-card__overlay--border'),
    trigger: target.querySelector<HTMLDivElement>('.expandable-card__trigger'),
  }

  const method = {
    init: () => {
      el.trigger.addEventListener('click', method.toggleCard)
    },

    getDiagonal: () => {
      const width = el.root.offsetWidth
      const height = el.root.offsetHeight
      
      return  Math.sqrt(width ** 2 + height ** 2)
    },

    toggleCard: () => {
      const collapseCard = () => {
        gsap
          .timeline()
          .set(el.root, { pointerEvents: 'none' })
          .set(el.overlayBorder, { borderWidth: 0, display: 'block', scale: 1, width: method.getDiagonal() * 2 })
          .to(el.overlayBorder, { borderWidth: method.getDiagonal() * 2, duration: 0.432, ease: 'power3.in' })
          .set(el.overlayBorder, { display: 'none' })
          .set(el.overlayBackground, { display: 'block', scale: 1, width: method.getDiagonal() * 2 })
          .set(el.expandedContent, {
            display: 'none',
            onComplete: () => {
              el.root.classList.remove('expandable-card--expanded')
            },
          })
          .to(el.overlayBackground, {
            duration: 0.654,
            ease: 'power4.out',
            onStart: () => {
              setTimeout(() => {
                el.trigger.classList.remove('expandable-card__trigger--purple')
              }, 321)
            },
            scale: 0,
          }, '>0.2')
          .set(el.expandedContent, { clearProps: 'display' })
          .set(el.root, { clearProps: 'pointerEvents' })
      }

      const expandCard = () => {
        gsap
          .timeline()
          .set(el.root, { pointerEvents: 'none' })
          .set(el.expandedContent, {
            display: 'none',
            onComplete: () => {
              el.root.classList.add('expandable-card--expanded')
              el.trigger.classList.add('expandable-card__trigger--purple')
            },
          })
          .set(el.overlayBackground, { width: method.getDiagonal() * 2 })
          .to(el.overlayBackground, { duration: 0.432, ease: 'power3.in', scale: 1 })
          .set(el.overlayBackground, { display: 'none' })
          .set(el.overlayBorder, { borderWidth: method.getDiagonal(), display: 'block', scale: 1, width: method.getDiagonal() * 2 })
          .set(el.expandedContent, { clearProps: 'display' })
          .to(el.overlayBorder, { borderWidth: 0, duration: 0.864, ease: 'power4.out' }, '>0.2')
          .set(el.root, { clearProps: 'pointerEvents' })
      }

      if (el.root.classList.contains('expandable-card--expanded')) {
        collapseCard()
      } else {
        expandCard()
      }
    },
  }

  method.init()
}
